<template>
  <div
    class="table-row-holder"
    :class="{'selected': checked}">
    <div
      @click="isDropOpened = !isDropOpened"
      class="table-row c-float" :class="{'has-detail-view' : detailView}">
      <!-- CHECKBOX - FIXED: Use :value and @change to match your Checkbox component -->
      <div v-if="checkbox" class="table-cell small">
        <Checkbox
          :value="checked"
          @change="onChange" />
      </div>
      <!-- TYPE -->
      <div v-if="type && type.type" class="table-cell small">
        <Icon
          :customClass="`circled-icon ${type.icons[listItem[type.data]]}-filled`"
          :circle=true
          :key="iconKey"
          :name="type.icons[`${listItem[type.data]}`]"
          size="20" />
      </div>
      <!-- TYPE IMAGE -->
      <div v-if="type && type.image" class="table-cell small">
        <div class="table-img">
          <img v-if="listItem[type.data]" :src="listItem[type.data]" />
          <svg viewBox="-13 -13 50 50" class="no-image" v-else><path d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'></path></svg>
        </div>
      </div>
      <!-- LISTED INFO -->
      <div
        class="table-cell"
        v-for="(optionItem, index) in computedData"
        :key="`row-${index}`">
        <p>
            <span
              :class="index === 0 && !singleLine ? 'main-info' : 'additional-info'"
              v-for="(value, key, spanIndex) in optionItem"
              :key="`span-${spanIndex}`">
               <component  :is="applyComponent[key]" v-if="applyComponent[key]" v-bind="bindToComponent(key)" />
              <span v-else v-html="parseColumnValue(listItem, key, value)" v-on="bindEvents(key)" :class="bindCss(key)"></span>
            </span>
        </p>
      </div>

      <!-- DETAIL-VIEW -->
      <div  class="table-cell x-small text-center show-advanced" v-if="detailView" @click="detailViewOpened = !detailViewOpened">
        <Icon
          class="icon"
          :name="detailViewOpened ? 'arrowDown' : 'arrowRight'"
          size="28" />
      </div>

      <!-- OPTIONS BUTTON -->
      <Btn
        v-if="rowActionParameter"
        class="button brand"
        :icon="{
          name: 'preview',
          size: '18',
        }"
        :btnText="rowActionParameter.text"
        @btnClick="rowAction"/>
    </div>
    <div class="table-row-dropdown-holder" v-if="isDropOpened && dropdown">
      <p>DROPDOWN PLACEHOLDER</p>
    </div>
    <div class="table-row-detail-view" v-if="detailViewOpened">
      <component :data="listItem" component="detailView" :is="detailView.component" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Btn from '@/components/elements/buttons';
import LogosSVG from '@/assets/images/logosSVG.vue';
import localesByCurrency from '@/data/localesByCurrency';
import DateMixin from "@/mixins/date";

export default {
  name: 'TableRow',
  components: {
    LogosSVG,
    Checkbox,
    Btn,
  },
  mixins: [DateMixin],
  props: [
    'checkbox',
    'logo',
    'checked',
    'listItem',
    'data',
    'singleLine',
    'type',
    'rowActionParameter',
    'dropdown',
    'iconKey',
    'detailView',
    'fieldFormatterConfiguration',
    'showRowValueWithPrefix'
  ],
  data() {
    return {
      selected: false,
      isDropOpened: false,
      detailViewOpened: false,
      applyComponent: {},
      applyComponentBindings: {},
      applyEvents: {},
      applyCssClass: {},
    };
  },

  computed: {
    computedData() {
      const computed = [];
      this.data.forEach(row => {
        Object.keys(row).forEach(key => {
          if (this.fieldFormatterConfiguration && this.fieldFormatterConfiguration[key]) {
            this.applyStructuralFormatting(this.fieldFormatterConfiguration[key], key, this.listItem[key])
          }
        })
        computed.push(row);
      })
      return computed;
    }
  },
  methods: {
    parseColumnValue(item, key, prefix) {
      let value = item[key];

      if (this.$route.name === 'contacts' && item.type === 1 && key === 'name') {
        value = item.company_name ?? value
      }

      if (this.$route.name === 'contact' && key === 'phone') {
        if (value && !value.startsWith('+')) {
          value = `+${value}`
        }
      }

      value = this.applyStringFormatting(key, value);

      return this.showRowValueWithPrefix ? `${prefix} ${value}` : value;
    },
    applyStringFormatting(key, value) {
      let formattedValue = value;

      if (this.fieldFormatterConfiguration && this.fieldFormatterConfiguration[key]) {
        this.fieldFormatterConfiguration[key].forEach(formatter => {
          if (value || value === 0) {
            if (formatter.type === 'currency' && !Number.isNaN(parseFloat(value))) {
              const currency = formatter.options.currency_key && this.listItem[formatter.options.currency_key]
                ? this.listItem[formatter.options.currency_key]
                : '';
              const conversion = formatter.options.conversion_key && this.listItem[formatter.options.conversion_key]
                ? this.listItem[formatter.options.conversion_key]
                : '';
              formattedValue = this.formatCurrency(value, conversion, currency);
            }
            if (formatter.type === 'dateTime') {
              formattedValue = this.formatDateTime(value, formatter.options.format);
            }
          }
        })
      }
      return formattedValue;
    },
    applyStructuralFormatting(fieldFormatters, key, value) {
      fieldFormatters.forEach(formatter => {
        if (formatter.type === 'component' && formatter.options && formatter.options.name) {
          this.applyComponent[key] = formatter.options.name;
          if (formatter.options.bind) {
            if (!this.applyComponentBindings[key]) {
              this.applyComponentBindings[key] = [];
            }
            formatter.options.bind.forEach(bindObject => {
              const obj = {}
              obj[bindObject.bindKey] = bindObject.dataKey ? this.listItem[bindObject.dataKey] : bindObject.data;
              this.applyComponentBindings[key].push(obj);
            })
          }
        }
        if (formatter.type === 'css') {
          if (formatter.options) {
            if (!this.applyCssClass[key]) {
              this.applyCssClass[key] = [];
            }
            if (formatter.options.conditionalRule === 'static' && formatter.options.classes) {
              this.applyCssClass[key].push(formatter.options.classes)
            }
            if (formatter.options.conditionalRule === 'zero_compare' && formatter.options.conditions) {
              if (value < 0 && formatter.options.conditions.negative) {
                this.applyCssClass[key].push(formatter.options.conditions.negative)
              }
              if (value > 0 && formatter.options.conditions.positive) {
                this.applyCssClass[key].push(formatter.options.conditions.positive)
              }
              if (value === 0 && formatter.options.conditions.equal) {
                this.applyCssClass[key].push(formatter.options.conditions.equal)
              }
            }
          }
        }
        if (formatter.type === 'event') {
          if (formatter.options) {
            if (!this.applyEvents[key]) {
              this.applyEvents[key] = [];
            }
            if (!this.applyCssClass[key]) {
              this.applyCssClass[key] = [];
            }
            if (formatter.options.behavior === 'link') {
              let {url} = formatter.options;
              let generateLink = false;
              Object.keys(formatter.options.params).forEach(param => {
                if (this.listItem[formatter.options.params[param]]) {
                  generateLink = true;
                  url = url.replace(`{${param}}`, this.listItem[formatter.options.params[param]]);
                }
              });

              if (generateLink) {
                const eventName = formatter.options.action;
                const eventFunction = () => this.$router.push(url);

                const event = {}
                event[eventName] = eventFunction
                this.applyEvents[key].push(event)
                this.applyCssClass[key].push('pointer color-brend bold')
              }
            }
          }
        }
      })
    },
    bindToComponent(key) {
      const bindObject = {};
      if (this.applyComponentBindings[key]) {
        this.applyComponentBindings[key].forEach(bind => {
          Object.assign(bindObject, bind);
        })
      }
      return bindObject;
    },
    bindEvents(key) {
      const bindObject = {};
      if (this.applyEvents[key]) {
        this.applyEvents[key].forEach(bind => {
          Object.assign(bindObject, bind);
        })
      }
      return bindObject;
    },
    bindCss(key) {
      if (this.applyCssClass[key]) {
        return this.applyCssClass[key].join(' ');
      }
      return '';
    },
    parseBetween(beginString, endString, originalString) {
      const beginIndex = originalString.indexOf(beginString);
      if (beginIndex === -1) {
        return null;
      }
      const beginStringLength = beginString.length;
      const substringBeginIndex = beginIndex + beginStringLength;
      const substringEndIndex = originalString.indexOf(endString, substringBeginIndex);
      if (substringEndIndex === -1) {
        return null;
      }
      return originalString.substring(substringBeginIndex, substringEndIndex);
    },
    formatCurrency(value, conversion, currency) {
      return this.$options.filters.currency(parseFloat(value), conversion, currency);
    },
    formatDateTime(value, format) {
      return DateMixin.parseUnknownDate(value).toFormat(format)
    },
    rowAction() {
      this.$emit('rowAction', this.listItem[`${this.rowActionParameter.param}`]);
    },

    onChange(isChecked) {
      // Your Checkbox component emits the boolean value
      console.log('TableRow onChange called for item:', this.listItem.id, 'isChecked:', isChecked);
      this.$emit('updateSelect', this.listItem.id);
    },
  }
}
</script>
